/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Stack } from '@mui/material';
import { useRecoilState } from 'recoil';
import { CssTextField } from 'components/select';
import { isISADocumentVaild, landingZoneForm, toggleCreateLandingZone } from '../../../store';

const IsaDocument = () => {
    const [lzModal] = useRecoilState(toggleCreateLandingZone);
    const [landZoneForm, setLandingZoneForm] = useRecoilState(landingZoneForm);
    const [isValid, setISADocumentVaild] = useRecoilState(isISADocumentVaild);
    const [ShrinkField, setShrinkField] = React.useState(false);

    const setISADocument = (ISADocument) => {
        if (!lzModal?.lzDetails) {
            setLandingZoneForm({
                ...landZoneForm,
                ISADocument,
            });
        }
    };

    const handleChange = (value) => {
        if (value !== '' && value !== null && value !== undefined) {
            if (value?.length > 10 || value?.length < 10) {
                setISADocumentVaild(false);
                setISADocument(value);
            } else if (!/^ISA[0-9]*$/.test(value)) {
                setISADocumentVaild(false);
                setISADocument(value);
            } else {
                setISADocumentVaild(true);
                setISADocument(value);
            }
        } else {
            setISADocumentVaild(false);
            setISADocument('');
        }
    };

    React.useEffect(() => {
        if (lzModal?.lzDetails?.config?.ISADocument) setISADocument(lzModal?.lzDetails?.config?.ISADocument);
    }, [lzModal?.lzDetails]);

    React.useEffect(() => {
        if (!ShrinkField) setShrinkField(landZoneForm?.ISADocument?.length > 0);
    }, [landZoneForm?.ISADocument]);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <CssTextField
                    size="small"
                    label="ISA Document"
                    fullWidth
                    onChange={(event) => handleChange(event.target.value)}
                    value={landZoneForm?.ISADocument}
                    InputLabelProps={{ shrink: ShrinkField }}
                    onClick={() => setShrinkField(true)}
                    // onBlur={() => landZoneForm?.ISADocument?.length > 0 && setShrinkField(false)}
                    autoComplete="off"
                    error={!isValid}
                    helperText={`
                    ${!isValid ? 'ISA Document should start with ISA<XXXXXXX> followed by 7 digit number. Ex.: ISA0123456' : ''}
                `}
                />
                {/* <InfoImg title="Type  Endpoint Name" /> */}
            </Stack>
        </>
    );
};

export default React.memo(IsaDocument);
